import { Modal, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

interface StreamVideoModalProps {
    open: boolean;
    onClose: () => void;
    videoUrl: string;
    title: string;
}

export default function StreamVideoModal({ open, onClose, videoUrl, title }: StreamVideoModalProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="stream-video-modal"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "95%", sm: "85%", md: "75%" },
                    maxWidth: 900,
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    overflow: 'hidden'
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'center',
                        p: 2,
                        borderBottom: 1,
                        borderColor: 'divider'
                    }}
                >
                    <Typography variant="h6" component="h2">
                        {title}
                    </Typography>
                    <IconButton onClick={onClose} size="small">
                        <Close />
                    </IconButton>
                </Box>

                {/* Video */}
                <Box
                    sx={{
                        position: "relative",
                        width: "100%",
                        paddingTop: "56.25%", // 16:9 Aspect Ratio
                        bgcolor: 'black'
                    }}
                >
                    <video
                        controls
                        controlsList="nodownload"
                        autoPlay
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <source src={videoUrl} type='video/mp4' />
                        Your browser does not support the video tag.
                    </video>
                </Box>
            </Box>
        </Modal>
    );
}
